<template>
  <CustomDialog
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    :closable="true"
  >
    <template #header>
      <span class="text-2xl text-text-primary dark:text-text-primary-dark">
        {{ title }}
      </span>
    </template>

    <template #content>
      <CustomFileUpload
        mode="advanced"
        @onFileSelected="onFileSelected"
        @handleLoadData="onExcelUpload"
      />
    </template>

    <template #footer>
      <div class="w-full flex items-center justify-between">
        <CustomButton
          variant="primary_outlined"
          label="Cancelar"
          @click="$emit('update:visible', false)"
        />

        <CustomButton
          :label="uploadButtonLabel"
          :disabled="!canUploadFile || disabled"
          @click="handleUploadClick"
        />
      </div>
    </template>
  </CustomDialog>
</template>

<script setup lang="ts">
import { ref } from "vue";

const props = defineProps({
  title: String,
  visible: Boolean,
  disabled: Boolean,
  uploadButtonLabel: { type: String, default: "Subir archivo" },
});

const emit = defineEmits([
  "update:visible",
  "onFileSelected",
  "onUploadFile", // archivo normal
  "onExcelUpload", // excel convertido a JSON
]);

const canUploadFile = ref(false);
const uploadingExcel = ref(false);

const currentFile = ref<File[]>([]);
const jsonToUpload = ref<any[]>([]);

// Cuando se selecciona archivo (Excel o cualquier otro)
function onFileSelected(files: File[]) {
  canUploadFile.value = files.length > 0;
  currentFile.value = files;
  uploadingExcel.value = false; // reset por si antes hubo excel
  emit("onFileSelected", files);
}

// Cuando el FileUpload procesa un Excel
function onExcelUpload(json: any[]) {
  uploadingExcel.value = true;
  jsonToUpload.value = json;
}

// -------- FLUJO UNIFICADO DEL BOTÓN ----------
function handleUploadClick() {
  if (uploadingExcel.value) {
    // Excel → enviar JSON
    emit("onExcelUpload", jsonToUpload.value);
  } else {
    // Archivo normal
    emit("onUploadFile", currentFile.value);
  }

  emit("update:visible", false);
}
</script>
